"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _LayoutPagingTable = _interopRequireDefault(require("01_core/components/layout/LayoutPagingTable"));
var _ListIconButton = _interopRequireDefault(require("01_core/components/materials/ListIconButton"));
var _DocumentLink = _interopRequireDefault(require("01_core/components/select/DocumentLink"));
var _DocumentUploadDelete = _interopRequireDefault(require("01_core/components/select/DocumentUploadDelete"));
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringConsts = require("01_core/constants/stringConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _bcmKunrenActions = require("../../bcmKunrenActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ドキュメント管理（訓練）：検索結果一覧表示部分
 */
const KunrenDocMngResult = function (props) {
  const {
    intl,
    goRegister,
    paging,
    changePage,
    searchResult,
    changeScrollTop,
    scrollTop,
    showAll,
    changeShowAll,
    changeViewNum,
    getCodeName,
    updateFile,
    isNewWindow,
    doSearch
  } = props;

  // 検索結果 = null (0件) の場合、null を返して終了。
  if (!searchResult) {
    return null;
  }

  // 検索結果ヘッダ
  const columns = [{
    dataKey: 'kunren_data',
    label: /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 1
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 3
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      color: "inherit",
      variant: "body2",
      component: "span"
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_TRAINING_NAME
    }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 4
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      color: "inherit",
      variant: "body2",
      component: "span"
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_KAISHA_SOSHIKI
    }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 4
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      color: "inherit",
      variant: "body2",
      component: "span"
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_BCP_TGT_JIGYO
    })))),
    width: 390
  }, {
    dataKey: 'kck_status',
    label: /*#__PURE__*/_react.default.createElement(_Typography.default, {
      color: "inherit",
      variant: "body2",
      component: "span"
    }, getCodeName(_CodeConsts.CODE.DOCUMENT_KIND.KBN, _CodeConsts.CODE.DOCUMENT_KIND.CODE_KCK)),
    width: 80
  }, {
    dataKey: 'kck_action',
    label: _stringConsts.STRING_CONSTS.EMPTY,
    direction: 'column',
    width: 70
  }, {
    dataKey: 'kjy_status',
    label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      color: "inherit",
      variant: "body2",
      component: "span"
    }, getCodeName(_CodeConsts.CODE.DOCUMENT_KIND.KBN, _CodeConsts.CODE.DOCUMENT_KIND.CODE_KJY)), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      color: "inherit",
      variant: "body2",
      component: "span"
    }, intl.formatMessage({
      id: _labelConsts.LABEL.BCM_KUNREN_SCENARIO
    }))),
    width: 85
  }, {
    dataKey: 'kjy_action',
    label: _stringConsts.STRING_CONSTS.EMPTY,
    direction: 'column',
    width: 70
  }, {
    dataKey: 'kjh_status',
    label: /*#__PURE__*/_react.default.createElement(_Typography.default, {
      color: "inherit",
      variant: "body2",
      component: "span"
    }, getCodeName(_CodeConsts.CODE.DOCUMENT_KIND.KBN, _CodeConsts.CODE.DOCUMENT_KIND.CODE_KJH)),
    width: 80
  }, {
    dataKey: 'kjh_action',
    label: _stringConsts.STRING_CONSTS.EMPTY,
    direction: 'column',
    width: 70
  }, {
    dataKey: 'file_status',
    label: /*#__PURE__*/_react.default.createElement(_Typography.default, {
      color: "inherit",
      variant: "body2",
      component: "span"
    }, getCodeName(_CodeConsts.CODE.DOCUMENT_KIND.KBN, _CodeConsts.CODE.DOCUMENT_KIND.CODE_KJK)),
    width: 120
  }, {
    dataKey: 'file_action',
    label: _stringConsts.STRING_CONSTS.EMPTY,
    direction: 'column',
    width: 50
  }];
  const createRow = data => {
    const getActionIcon = (data, status, documentKindCd, content) => {
      return /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
        action: status === _CodeConsts.CODE.BCM_KR_PROG_CD.CODE_1 ? 'update' : 'register',
        onClick: () => goRegister({
          targetCd: data.targetCd,
          kunrenNm: data.kunrenNm,
          bcmKaishaSoshikiCd: data.bcmKaishaSoshikiCd,
          bcmKaishaSoshikiNm: data.bcmKaishaSoshikiNm,
          bcpTgtJigyoCd: data.bcpTgtJigyoCd,
          bcpTgtJigyoNm: data.bcpTgtJigyoNm,
          documentKindCd: documentKindCd,
          kunrenNendo: data.kunrenNendo
        }, content)
      });
    };
    const getStatusData = (updDt, statusCd) => {
      return /*#__PURE__*/_react.default.createElement(_Box.default, {
        sx: {
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5
        }
      }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
        variant: "body2",
        component: "span"
      }, updDt), /*#__PURE__*/_react.default.createElement(_Typography.default, {
        variant: "body2",
        component: "span"
      }, getCodeName(_CodeConsts.CODE.BCM_KR_PROG_CD.KBN, statusCd)));
    };

    // 訓練名、会社／組織、BCP対象事業
    const kunren_data = /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 1
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 3
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2",
      component: "span"
    }, data.kunrenNm)), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 4
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2",
      component: "span"
    }, data.bcmKaishaSoshikiNm)), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 4
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2",
      component: "span"
    }, data.bcpTgtJigyoNm)));

    // 訓練中期計画
    const kck_status = /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, getStatusData(data.kckUpdDt, data.kckStatusCd)));
    const kck_action = /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, getActionIcon(data, data.kckStatusCd, _CodeConsts.CODE.DOCUMENT_KIND.CODE_KCK, _bcmKunrenActions.CONTENTS.MEDPLAN_ENTRY)));

    // 訓練実施要領
    const kjy_status = /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, getStatusData(data.kjyUpdDt, data.kjyStatusCd)));
    const kjy_action = /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, getActionIcon(data, data.kjyStatusCd, _CodeConsts.CODE.DOCUMENT_KIND.CODE_KJY, _bcmKunrenActions.CONTENTS.GUIDANCE_ENTRY)));

    // 訓練実施報告
    const kjh_status = /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, getStatusData(data.kjhUpdDt, data.kjhStatusCd)));
    const kjh_action = /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, getActionIcon(data, data.kjhStatusCd, _CodeConsts.CODE.DOCUMENT_KIND.CODE_KJH, _bcmKunrenActions.CONTENTS.REPORT_ENTRY)));

    // 訓練補足資料
    let file_status = /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, data.fileNm ? /*#__PURE__*/_react.default.createElement(_Box.default, {
      sx: {
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5
      }
    }, /*#__PURE__*/_react.default.createElement(_DocumentLink.default, {
      dispFileNm: data.fileNm,
      fileNm: data.fileNm,
      siteKindCd: data.siteKindCd,
      targetCd: data.targetCd,
      bcmKaishaSoshikiCd: data.bcmKaishaSoshikiCd,
      bcpTgtJigyoCd: data.bcpTgtJigyoCd,
      documentKindCd: _CodeConsts.CODE.DOCUMENT_KIND.CODE_KJK
    }), showAll && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, data.fileNote && /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2",
      component: "div"
    }, data.fileNote), data.fileUpdDt && /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2",
      component: "div"
    }, data.fileUpdDt))) : _stringConsts.STRING_CONSTS.HYPHEN_ZENKAKU));
    const file_action = /*#__PURE__*/_react.default.createElement(_DocumentUploadDelete.default, {
      siteKindCd: data.siteKindCd,
      targetCd: data.targetCd,
      bcmKaishaSoshikiCd: data.bcmKaishaSoshikiCd,
      bcpTgtJigyoCd: data.bcpTgtJigyoCd,
      documentKindCd: _CodeConsts.CODE.DOCUMENT_KIND.CODE_KJK,
      trainingName: data.kunrenNm,
      kaishaSoshikiNm: data.bcmKaishaSoshikiNm,
      bcpTgtJigyoNm: data.bcpTgtJigyoNm,
      documentKindNm: getCodeName(_CodeConsts.CODE.DOCUMENT_KIND.KBN, _CodeConsts.CODE.DOCUMENT_KIND.CODE_KJK),
      onChange: obj => {
        updateFile(obj, data);
      }
    });
    return {
      kunren_data,
      kck_status,
      kck_action,
      kjy_status,
      kjy_action,
      kjh_status,
      kjh_action,
      file_status,
      file_action
    };
  };
  return /*#__PURE__*/_react.default.createElement(_LayoutPagingTable.default, {
    title: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_SEARCH_RESULT_LIST
    }),
    rowData: searchResult,
    headerHeight: 80,
    createRow,
    columns,
    paging,
    changeViewNum,
    changePage,
    scrollTop: scrollTop,
    onScroll: changeScrollTop,
    changeCurrentPage: changePage,
    changeViewNum: changeViewNum,
    showAll: showAll,
    showAllLabel: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_SHOW_DETAIL
    }),
    changeShowAll: changeShowAll,
    isNewWindow: isNewWindow,
    reload: doSearch
  });
};
const mapStateToProps = state => ({
  previousConditions: state.bcmKunren.previousConditions,
  searchResult: state.bcmKunren.searchResult,
  paging: state.bcmKunren.paging,
  scrollTop: state.bcmKunren.scrollTop,
  showAll: state.bcmKunren.showAll,
  doSearch: state.bcmKunren.doSearch
});
const mapDispatchToProps = dispatch => ({
  changeScrollTop: scrollTop => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.CHANGE_SCROLL_TOP](scrollTop)),
  changePage: currentPage => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.CHANGE_PAGE](currentPage)),
  changeShowAll: showAll => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.CHANGE_SHOW_ALL](showAll)),
  changeViewNum: viewNum => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.CHANGE_VIEW_NUM](viewNum)),
  goRegister: (kunrenInfo, content) => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.GO_REGISTER](kunrenInfo, content)),
  updateFile: (fileInfo, data) => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.UPDATE_FILE](fileInfo, data))
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _CodeUtil.withCodeUtil)((0, _reactIntl.injectIntl)(KunrenDocMngResult)));